import moment from 'moment';
import Image from 'next/image';
import Link from 'next/link';
import React, { useEffect, useRef, useState } from 'react';

import { useAuth } from '@/api/auth/auth';
import DummyImage from '@/assets/images/dummy-user.svg';
import HeaderLogo from '@/assets/images/icons/MFO-main-logo-White.svg';
import routes from '@/routes/routes.json';
import useMoengageStore from '@/store/moengage';
import { createMoengageEvent } from '@/utils/moengage';

import { HeaderMobile } from './HeaderMobile';
import { HeaderWeb } from './HeaderWeb';

export const Header = () => {
  const [showSideBar, setShowSideBar] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const { isLoggedIn, logout } = useAuth();

  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setShowProfileDropdown(showProfileDropdown);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [containerRef]);

  const { loginSignupClicked } = useMoengageStore(
    (state) => state.loginSignupClicked
  );

  return (
    <>
      <nav className="mainNav navbar fixed-top navbar-expand-lg bg-scroll">
        <div className="custom-header-mobile container">
          <div className="nav-right">
            <Link className="navbar-brand" href="/" id="header_muthoot-logo">
              <Image
                style={{ color: undefined }}
                className="img-fluid mfo-logo-header"
                src={HeaderLogo}
                alt="Muthoot Logo"
              />
              <span className="sr-only">Muthoot Logo</span>
            </Link>

            <div
              className={`hamburger hamburger--squeeze ${
                showSideBar && 'is-active'
              }`}
              aria-controls="header-menu"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={() => setShowSideBar(!showSideBar)}
            >
              <div className="hamburger-box">
                <div className="hamburger-inner"></div>
              </div>
            </div>
          </div>
          {/* PREVIOUS CODE */}
          {/* For current reversal reference Check PreviousHeader.html and replace
          here */}
          {/*  */}
          {/* New design */}
          <HeaderWeb />
          {isLoggedIn ? (
            <div
              className="post-login-btn nav-drop-menu text--semi"
              id="userLogin"
              onClick={() => setShowProfileDropdown(!showProfileDropdown)}
            >
              <Image
                style={{ color: undefined }}
                className="img-fluid"
                src={DummyImage}
                alt="user icon"
              />
              <p className="text--white name">
                {/* {userDetails?.firstName
                  ? userDetails?.firstName.slice(0, 5)
                  : 'User'} */}
                Me
              </p>
              <div
                className={`nav-menu ${
                  showProfileDropdown ? 'd-block' : 'd-none'
                }`}
                // style={{ display: `${showProfileDropdown ? 'block' : 'none'}` }}
                id="userLoginDrop"
                ref={containerRef}
              >
                <ul>
                  <li>
                    <Link
                      href={`${routes.accountSettings}#profile`}
                      className="nav-menu-link"
                      id="header_settings"
                    >
                      Settings
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/help"
                      className="nav-menu-link"
                      id="header_help"
                    >
                      Help
                    </Link>
                  </li>
                  <li>
                    <a
                      className="nav-menu-link"
                      onClick={logout}
                      id="header_logout"
                    >
                      Logout
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          ) : (
            <Link
              onClick={() => {
                createMoengageEvent(loginSignupClicked, {
                  created_date: moment.now(),
                  mobile_number: undefined,
                });
              }}
              className="login-btn"
              data-toggle="modal"
              data-target="#signupModal"
              href="/auth"
              id="header_sign-up"
            >
              <span className=" text--semi">Login / Signup</span>
            </Link>
          )}
        </div>
      </nav>
      <HeaderMobile open={showSideBar} setOpen={setShowSideBar} />
    </>
  );
};
